import type { Middleware } from '@reduxjs/toolkit';
import { type Socket, io } from 'socket.io-client';

import { getClientToken } from '@/shared/services/user-hash';
import { setShouldUpdateLeasing, setWsIsConnected } from '@/store/app.slice';
import type { TRootState } from '@/store/store';

let socket: Socket | null = null;

export const wsMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  const { isUserAuth } = (storeAPI.getState() as TRootState).auth;
  const wsIsConnected = (storeAPI.getState() as TRootState).app.wsIsConnected;
  const { accessToken } = getClientToken();
  const socketIoHost = process.env.PUBLIC_SOCKET_URL;

  if (isUserAuth && accessToken && !socket && !wsIsConnected && socketIoHost) {
    socket = io(socketIoHost, {
      transports: ['websocket', 'polling', 'webtransport'],
      auth: {
        token: getClientToken()
      }
    });

    socket.on('connect', () => {
      storeAPI.dispatch(setWsIsConnected(true));
    });

    socket.on('connect_error', () => {
      storeAPI.dispatch(setWsIsConnected(false));
    });

    socket.on('PartnerLeasing_Updated', (data: { payload?: unknown }) => {
      if (data?.payload) {
        storeAPI.dispatch(setShouldUpdateLeasing(true));
      }
    });
  } else if ((!isUserAuth || !accessToken) && socket) {
    socket.disconnect();
    socket = null;
    storeAPI.dispatch(setWsIsConnected(false));
  }

  return next(action);
};
